import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "Utils/Cards/Card";
import { Listado } from "./components/Listado";
import "./styles/HistorialTraslados.css";

class HistorialTraslados extends Component {
    render() {
        const { user } = this.props;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <Card
                    icon="produccion_activo"
                    titulo="Bodega producto terminado"
                    subtitulo="Traslados conforme/no conforme"
                    noBorder
                >
                    <Listado storageKey="prod_bod_control_calidad_state" />
                </Card>
            </div>
        );
    }
}

const mstp = (state) => {
    const user = state.login.me;

    return {
        user,
    };
};

export default connect(mstp, {})(HistorialTraslados);
